import { combineReducers } from '@reduxjs/toolkit'

import authReducer from './Auth/auth'
import transactionReducer from './Transactions/transaction'
import tradeReducer from './Trade/trade'
import rateReducer from './Rates/rate'

const appReducer = combineReducers({
    auth: authReducer,
    transaction: transactionReducer,
    trade: tradeReducer,
    rate: rateReducer,
})

const rootReducer = (state, action) => {
    if (action.type === 'auth/Logout') {
      state = undefined;
    }
    return appReducer(state, action);
  };

export default rootReducer

